export const INBOX = 'INBOX';
export const SENT = 'SENT';
export const TRASH = 'TRASH';
